import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=c1f1971a&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=c1f1971a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f1971a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f1971a')) {
      api.createRecord('c1f1971a', component.options)
    } else {
      api.reload('c1f1971a', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=c1f1971a&scoped=true&", function () {
      api.rerender('c1f1971a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Main.vue"
export default component.exports